<template>
  <settings-card :message="'Bienvenue sur Learn and Watch !'">
    <template v-slot:title>
      A quel(s) service(s) de VOD as-tu accès ?
    </template>
    <template v-slot:content>
        <div class="VODcontent" v-if="!vodValidated">
          <div  class="flexwrap centercenter">
            <VODbutton :imageUrl="'https://learnandwatch.s3.eu-west-3.amazonaws.com/VODImages/Netflix_Logo_RGB.png'" v-model="netflix"></VODbutton>
            <VODbutton :imageUrl="'https://learnandwatch.s3.eu-west-3.amazonaws.com/VODImages/1280px-Amazon_Prime_Video_logo.svg.png'" v-model="prime_video"></VODbutton>
            <VODbutton :imageUrl="'https://learnandwatch.s3.eu-west-3.amazonaws.com/VODImages/OCS_logo.png'" v-model="ocs"></VODbutton>
            <VODbutton :imageUrl="'https://learnandwatch.s3.eu-west-3.amazonaws.com/VODImages/Disney%2B_logo-svg.png'" v-model="disney"></VODbutton>
            <VODbutton :imageUrl="'https://learnandwatch.s3.eu-west-3.amazonaws.com/VODImages/2560px-Apple_TV_Plus_Logo.svg.png'" v-model="apple_tv"></VODbutton>
            <VODbutton :imageUrl="'https://learnandwatch.s3.eu-west-3.amazonaws.com/VODImages/1280px-YouTube_Premium_logo.svg.png'" v-model="youtube"></VODbutton>
            <VODbutton :imageUrl="'https://learnandwatch.s3.eu-west-3.amazonaws.com/VODImages/MEA-Canal-VOD.png'" v-model="canal"></VODbutton>
          </div>

          <standard-button id="saveProfileButton" @click="vodValidated = true" :inactive="saveInactive" :color-class="'olive'">Valider</standard-button>
        </div>
        <div class="VODcontent centercenter" v-else-if="!netflix">
          <strong><i class="fa-solid fa-circle-exclamation"></i> Nous ne disposons pour le moment que du catalogue Netflix.</strong>
          <br>Tu pourras profiter de toutes les fonctionnalités liées à l'apprentissage du vocabulaire.
          <br>Mais pas de l'immersion directe dans la langue anglaise.
          <standard-button id="saveProfileButton" @click="saveChanges" :inactive="saveInactive" :color-class="'olive'">Continuer quand même</standard-button>
        </div>

    </template>

  </settings-card>
</template>

<script>
import SettingsCard from "@/components/settingsCard";
import {manageUserDatas} from "@/mixins/manageUserDatas";
import StandardButton from "@/components/standardButton";
import VODbutton from "@/components/VODbutton";

export default {
name: "userVODServices",

  mixins: [manageUserDatas],

  components: {
    VODbutton,
    StandardButton,
    SettingsCard,
  },

  created() {
    this.tempProfile.streaming_services.forEach((element) => {
      this[element] = true
    })
  },

  methods: {
    setService: function(service) {
      this.tempProfile.streaming_services.push(service)
    },

    removeService: function(service) {
      console.log('remove : ' + service)
      let index = this.tempProfile.streaming_services.findIndex(element => element === service);
      console.log(index)
      this.tempProfile.streaming_services.splice(index, 1)
    }
  },

  watch: {
    'vodValidated': function() {
      this.tempProfile.streaming_services = [];

      if(this.netflix) {
        this.setService('netflix')
      }
      if(this.prime_video) {
        this.setService('prime_video')
      }
      if(this.ocs) {
        this.setService('ocs')
      }
      if(this.disney) {
        this.setService('disney')
      }
      if(this.apple_tv) {
        this.setService('apple_tv')
      }
      if(this.youtube) {
        this.setService('youtube')
      }
      if(this.canal) {
        this.setService('canal')
      }

      if(this.netflix) {
        this.saveChanges()
      }
    },
    /*
    'netflix': function() {
      if(this.netflix) {
        this.setService('netflix')
      }
      else {
        this.removeService('netflix')
      }
    },

    'prime_video': function() {
      if(this.prime_video) {
        this.setService('prime_video')
      }
      else {
        this.removeService('prime_video')
      }
    },

    'ocs': function() {
      if(this.ocs) {
        this.setService('ocs')
      }
      else {
        this.removeService('ocs')
      }
    },

    'disney': function() {
      if(this.disney) {
        this.setService('disney')
      }
      else {
        this.removeService('disney')
      }
    },

    'apple_tv': function() {
      if(this.apple_tv) {
        this.setService('apple_tv')
      }
      else {
        this.removeService('apple_tv')
      }
    },

    'youtube': function() {
      if(this.youtube) {
        this.setService('youtube')
      }
      else {
        this.removeService('youtube')
      }
    },

    'canal': function() {
      if(this.canal) {
        this.setService('canal')
      }
      else {
        this.removeService('canal')
      }
    },*/
  },

  data() {
    return {
      tempProfile: {
        streaming_services: []
      },
      netflix:false,
      prime_video:false,
      ocs:false,
      disney:false,
      apple_tv:false,
      youtube:false,
      canal:false,
      vodValidated: false,
      saveInactive: false,
    }
  }
}
</script>

<style scoped>

  .VODcontent{
    display: grid;
    width: 50vw;
    max-width: 50vw;
    height: calc(100% - 2vw);
    max-height: calc(100% - 2vw);
    grid-template-rows: auto 1fr;
    position: relative;
    grid-gap: 1vw;
    padding: 1vw;
    /*border: 0.1vw var(--goalBackgroundColor) solid;
    border-radius: 1vw;*/
  }

  @media screen and (max-device-width: 767px) {

    .VODcontent {
      width: 90%;
      max-width: 90%;
      height: calc(100% - 8vw);
      max-height: calc(100% - 8vw);
      grid-gap: 4vw;
      padding: 4vw;
      position: relative;
      justify-self: center;
    }
  }
</style>